import { ValueError } from "../../Errors/ValueError";
import { GraphDataClass } from "./GraphDataClass";
import { EnsembleGraphDataClass } from './EnsembleGraphDataClass';
import { NetworkError } from "../../Errors/NetworkError";
/**
 * Represents a collection of EnsembleGraphDataClass
 */
export class EnsembleOfGraphdata {
    constructor(ensemblesData) {
        if (ensemblesData === undefined) {
            this.graphData = [];
        }
        else {
            this.graphData = ensemblesData; // TODO: make this ensemblesData.slice() to copy by value
        }
    }
    roundAllValues(numberOfDP = 2) {
        this.graphData.map(g => g.roundAllValues(numberOfDP));
    }
    /**
     * Also untested, beware!
     * @param timestamp
     * @param includeUndefined
     * @returns
     */
    getValuesAtTimeStamp(timestamp, includeUndefined = false) {
        let values = this.graphData.map(d => d.getValueAtTimeStamp(timestamp));
        if (includeUndefined)
            return values;
        else
            return values.filter(d => d !== undefined);
    }
    get maxDate() {
        return this.graphData[0].timeSeries[this.graphData[0].timeSeries.length - 1];
    }
    get minDate() {
        return this.graphData[0].timeSeries[0];
    }
    /**
     * Returns the data as an array of chart datasets with styling.
     * @param styleName
     * @param yAxisID
     * @param label required because of logic of this function
     */
    //public toChartDatasets(styleName: string, yAxisID: string, label: string):ChartDataSets[] {
    //    //not used
    //    let style = StyleBuilder.getStyle(styleName);
    //    let displayFlag = true;
    //    // We only want ONE of the series to have a label.
    //    // Otherwise you'll get one legend entry per ensemble.
    //    // Series with the label "_ensemble" won't get displayed in the legend.
    //    console.log('to chart ' + label);
    //    return this.graphData.map(data => {
    //        //let chartData = data.toChartDataset();
    //        if (displayFlag) {
    //            console.log('am here');
    //            label = label;
    //            displayFlag = false;
    //        } else {
    //            console.log('this bit')
    //            label = "_ensemble";
    //        }
    //        return {...data.toChartDataset(styleName,yAxisID),label:label};
    //    })
    //}
    extendAllTimeseries(startDate, endDate) {
        this.graphData.forEach(data => data.extendTimeSeries(startDate, endDate));
    }
    /**
     *
     * @param startDate
     * @param endDate
     * @returns
     */
    filterAllByTimeSeries(minTime, maxTime) {
        let ensemblesData = this.graphData.map(d => d.filterByMinMaxDate(minTime, maxTime));
        return new EnsembleOfGraphdata(ensemblesData);
    }
    /**
     * Given an array of floats, calculates the percentiles of the ensembles for those floats.
     * Replaces 0s with null values to stop them being plotted
     * @example
     * You have 3 ensembles, each with 3 elements
     * generateQuantileEnsembles([.25,.50,.75]) returns
     * [[1,5,7],[15,53,72],[17,54,71]]
     * @param quantiles
     */
    generateQuantileEnsembles(quantiles) {
        if (quantiles.some(q => q > 1 || q < 0) === true) {
            throw new ValueError("Quantiles must be between 0 and 1");
        }
        var getValuesAtSlice = (index) => {
            if (index < 0 || index > this.graphData[0].length) {
                throw new ValueError(`Slice at index ${index} does not exist`);
            }
            return this.graphData.map(d => d.values[index]);
        };
        const quantile = (arr, q) => {
            const sorted = arr.sort((a, b) => a - b);
            const pos = (sorted.length - 1) * q;
            const base = Math.floor(pos);
            const rest = pos - base;
            if (sorted[base + 1] !== undefined) {
                return sorted[base] + rest * (sorted[base + 1] - sorted[base]);
            }
            else {
                return sorted[base];
            }
        };
        let restrucutred = [];
        let quantilesResult = [];
        for (let i = 0; i < this.graphData[0].length; i++) {
            restrucutred.push(getValuesAtSlice(i));
        }
        restrucutred.forEach(r => {
            //@ts-ignore
            quantilesResult.push(quantiles.map(q => quantile(r, q)));
        });
        let valuesArray = new Array(quantilesResult[0].length);
        for (let i = 0; i < valuesArray.length; i++) {
            valuesArray[i] = [];
        }
        for (let innerIndex = 0; innerIndex < quantilesResult[0].length; innerIndex++) {
            quantilesResult.forEach(array => valuesArray[innerIndex].push(array[innerIndex]));
        }
        //@ts-ignore I don't want to bite the bullet and make it number | null
        valuesArray = valuesArray.map(x => x.map(d => d === 0 ? null : d));
        return valuesArray.map(v => new GraphDataClass(this.graphData[0].timeSeries, v));
    }
    generateAverageEnsemble() {
        let timeSeries = this.graphData[0].timeSeries;
        let valueSumArray = new Array(timeSeries.length).fill(0);
        for (let i = 0; i < timeSeries.length; i++) {
            for (let j = 0; j < this.graphData.length; j++) {
                let ensemble = this.graphData[j];
                let valueToAdd = ensemble.values[i] === null ? 0 : ensemble.values[i];
                valueSumArray[i] += valueToAdd;
            }
        }
        let averages = valueSumArray.map(v => Math.round((v / this.graphData.length) * 1e2) / 1e2);
        return new GraphDataClass(timeSeries, averages);
    }
    /**
     * FIXME: We are only getting a single ensemble through at a time, and they are both the same!
     * */
    generateMinMaxEnsemble() {
        let ensembleData = this.graphData;
        let seriesLength = ensembleData[0].timeSeries.length;
        let minEnsemble = new GraphDataClass(new Array(seriesLength), new Array(seriesLength).fill(Infinity));
        minEnsemble.timeSeries = ensembleData[0].timeSeries;
        let maxEnsemble = new GraphDataClass(new Array(seriesLength), new Array(seriesLength).fill(-Infinity));
        maxEnsemble.timeSeries = ensembleData[0].timeSeries;
        for (let ensembleCount = 0; ensembleCount < ensembleData.length; ensembleCount++) {
            let currentEnsemble = ensembleData[ensembleCount];
            for (let timeStep = 0; timeStep < currentEnsemble.timeSeries.length; timeStep++) {
                let currentValue = currentEnsemble.values[timeStep];
                let minEnsemblevalue = minEnsemble.values[timeStep];
                //@ts-ignore
                if (currentValue < minEnsemblevalue) {
                    minEnsemble.values[timeStep] = currentValue;
                }
                let maxEnsembleValue = maxEnsemble.values[timeStep];
                //@ts-ignore
                if (currentValue > maxEnsembleValue) {
                    maxEnsemble.values[timeStep] = currentValue;
                }
            }
        }
        return [minEnsemble, maxEnsemble];
    }
    /**
     * Right now only number is supported, otherwise we'd make this one generic too
     * @param apiResponse
     * @returns
     */
    static fromEnsembleAPIResponse(apiResponse) {
        let ensembleData = [];
        let newEnsemble = new EnsembleOfGraphdata();
        if (apiResponse.timeSeries === undefined) {
            throw new NetworkError(`Invalid API response for url: ${apiResponse.originalURL}`);
        }
        if (apiResponse.timeSeries.length === 0) {
            //Probably developer error as well.
            throw new ValueError(`Expected at least 1 timeseries but got none.`);
        }
        apiResponse.timeSeries.forEach(series => {
            //Probably developer error as well.
            if (series.header.ensembleMemberId === undefined)
                throw new ValueError(`No ensemble id on series ${series.header.stationName}`);
        });
        let missingDataValue = apiResponse.timeSeries[0].header.missVal;
        if (missingDataValue === undefined) {
            throw new ValueError("Missing data value was undefined. Check JSON response schema");
        }
        apiResponse.timeSeries.forEach(series => {
            let ensembleDatum = new EnsembleGraphDataClass(series.header.ensembleMemberId, [], []);
            series.events.forEach(event => {
                var d = new Date(`${event.date}T${event.time}Z`);
                ensembleDatum.timeSeries.push(d.toISOString());
                if (event.value === missingDataValue) {
                    //@ts-ignore
                    ensembleDatum.values.push(null);
                }
                else {
                    ensembleDatum.values.push(Number.parseFloat(event.value));
                }
            });
            ensembleData.push(ensembleDatum);
        });
        newEnsemble.graphData = ensembleData;
        return newEnsemble;
    }
}
